import { type InitResult } from '@airwallex/components-sdk'
import { useQuery } from 'react-query'

import { financialAccountQueryConfig } from '@webapp/platform/banking/query-configs/financialAccount'

export const useQueryScaToken = ({
  initResult,
  verifyOnMount,
  openScaVerificationModal,
}: {
  initResult: Nullable<InitResult> | undefined
  verifyOnMount: boolean
  openScaVerificationModal: () => void
}) => {
  const { data: scaToken, isFetching: isFetchingScaToken } = useQuery({
    queryKey: financialAccountQueryConfig.getScaToken().queryKey,
    queryFn: () => {
      return initResult?.sca?.getScaToken()
    },
    enabled: !!initResult?.sca,
    staleTime: 1000 * 60 * 4,
    onSettled: (token) => {
      if (!token && verifyOnMount) {
        openScaVerificationModal()
      }
    },
  })

  return {
    scaToken,
    isFetchingScaToken,
  }
}
